/* C-3088 exit offer (VZ), from Suzy's exit.html. Shows on DESKTOP exit intent only (the pointer leaves through the top of the
   window), at most once per visit (sessionStorage), never before min_seconds_on_page, and never while another dialog, drawer or
   Klaviyo form is open. Focus is trapped while open and returned on close; Escape, the x, "No thanks" and the dim all close it.
   Sending (ORION ruling, C-3088): unticked = no Klaviyo call, the comparison is shown on screen; ticked = club-list subscription
   (double opt-in, custom_source exit-offer) plus the event SD's C-3083 flow sends the comparison email from. */
(function () {
  /* one cover per visit, shared with T2's chat invitation (SD): skip if set, set when shown */
  var KEY = 'nt_overlay_shown';
  function storeGet() { try { return sessionStorage.getItem(KEY); } catch (e) { return '1'; } }
  function storeSet() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }

  function otherOverlayOpen(root) {
    var sel = '#nt-chat .nt-invite, #nt-chat.is-open, [role="dialog"][aria-modal="true"], dialog[open], .klaviyo-form, [class*="kl-private-reset"], [id^="CartDrawer"], cart-drawer, .drawer.active, .drawer[open], .modal.is-open, .menu-drawer[open]';
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (root.contains(el)) continue;
      var r = el.getBoundingClientRect(), cs = getComputedStyle(el);
      if (r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none' && cs.opacity !== '0') return true;
    }
    return document.documentElement.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden');
  }

  function init(root) {
    if (root.dataset.ntxInit) return; root.dataset.ntxInit = '1';
    var card = root.querySelector('[data-ntx-card]'), dim = root.querySelector('[data-ntx-dim]');
    var form = root.querySelector('[data-ntx-form]'), em = root.querySelector('[data-ntx-email]'), club = root.querySelector('[data-ntx-club]');
    var err = root.querySelector('[data-ntx-error]'), last = null, armedAt = Date.now() + (+root.dataset.delayMs || 0);
    var desktop = window.matchMedia('(min-width: 821px) and (pointer: fine)').matches;
    var q = new URLSearchParams(location.search).get('exit_offer'); // preview: ?exit_offer=show
    function focusables() { return [].slice.call(card.querySelectorAll('button,input')).filter(function (e) { return e.offsetParent !== null; }); }
    function show() {
      last = document.activeElement; card.hidden = false;
      requestAnimationFrame(function () { card.classList.remove('leaving'); card.classList.add('show'); dim.classList.add('show'); });
      storeSet();
      setTimeout(function () { (window.innerWidth > 700 ? em : card).focus({ preventScroll: true }); }, 420);
    }
    function hide() {
      card.classList.add('leaving'); dim.classList.remove('show');
      setTimeout(function () { card.classList.remove('show', 'leaving'); card.hidden = true; if (last && last.focus) last.focus(); }, 200);
    }
    root.querySelector('[data-ntx-close]').onclick = hide; root.querySelector('[data-ntx-no]').onclick = hide; dim.onclick = hide;
    document.addEventListener('keydown', function (e) {
      if (!card.classList.contains('show')) return;
      if (e.key === 'Escape') { hide(); return; }
      if (e.key === 'Tab') {
        var f = focusables(), a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
    function fail(msg) { err.textContent = msg; err.hidden = false; }
    function sent(ticked) {
      root.querySelector('[data-ntx-done-plain]').hidden = ticked;
      root.querySelector('[data-ntx-done-club]').hidden = !ticked;
      card.classList.add('sent');
      card.classList.toggle('plain', !ticked); /* ORION: no envelope icon when no email was sent */
      setTimeout(function () { root.querySelector('[data-ntx-compare]').focus(); }, 300);
    }
    function kl(path, payload) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(root.dataset.company), {
        method: 'POST', headers: { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' }, body: JSON.stringify(payload)
      }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); err.hidden = true;
      var ticked = club.checked, ready = root.dataset.company && root.dataset.event;
      /* ORION: the email is required only with the Club tick. Unticked, a typed address is dropped here and never sent or stored. */
      if (!ticked) { em.value = ''; sent(false); return; }
      var v = (em.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { em.focus(); em.style.borderColor = '#B5462F'; fail('Please enter a valid email address.'); return; }
      /* ORION ruling (data minimisation): unticked = NO Klaviyo call at all; the comparison is shown on screen.
         Ticked = event "Requested Comparison" {store, product, club_opt_in:true} (SD's C-3083 flow) + club-list subscription
         (double opt-in). Nobody is unsubscribed or suppressed. */
      var event = ready ? kl('events', { data: { type: 'event', attributes: {
          properties: { store: root.dataset.store, product: root.dataset.product || '', club_opt_in: ticked },
          metric: { data: { type: 'metric', attributes: { name: root.dataset.event } } },
          profile: { data: { type: 'profile', attributes: { email: v } } } } } }) : null;
      if (!ready || !root.dataset.clubList) { fail("Sorry, we can't sign you up right now. Please try again later."); return; }
      Promise.all([event, kl('subscriptions', { data: { type: 'subscription', attributes: { custom_source: root.dataset.source,
          profile: { data: { type: 'profile', attributes: { email: v, properties: { signup_source: root.dataset.signupSource } } } } },
          relationships: { list: { data: { type: 'list', id: root.dataset.clubList } } } } })])
        .then(function () { sent(true); }).catch(function () { fail("Sorry, that didn't go through. Please try again."); });
    });
    if (q === 'show') { show(); return; }
    if (!desktop || storeGet()) return;
    document.addEventListener('mouseout', function onOut(e) {
      if (e.relatedTarget || e.toElement || e.clientY > 0) return;
      if (Date.now() < armedAt || storeGet() || otherOverlayOpen(root)) return;
      document.removeEventListener('mouseout', onOut); show();
    });
  }
  function boot() { [].slice.call(document.querySelectorAll('[data-ntx]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
